import React, { useState, useEffect } from 'react'
import { Autocomplete, Box, Button, Divider, TextField } from '@mui/material'
import { RootState } from '../../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from '../Pathologist/inboxStyles'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import { UserBannerPathologist } from '../../../interfaces/calendar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import CircularProgress from '@mui/material/CircularProgress'
import { correction, fetchUsersData, getLabManagerCompleteData, getSearchByTRFData } from '../../../actions'

export default function TransferCorrectCaseModal({
  userId,
  isSearch,
  trfId,
  open,
  onClose,
  userDetails,
  setFirstPage,
  filterName,
  filterValue,
  sortField,
  startDate,
  endDate,
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const gridPageSize = 10
  const { role, user } = useSelector((state: RootState) => state.userLogin)
  const { re_correction_success, re_correction_error } = useSelector((state: RootState) => state.correctionResponse)
  const getUsers = useSelector((state: RootState) => state.getUsers)
  const [newUserId, setUserId] = useState(null)
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [loading, setLoading] = useState(false)
  const [isTranferListLoading, setTranferListLoading] = useState(true)
  const getClassNames = () => (disableSubmit ? `${classes.disableBtn} ` : `${classes.btn} ${classes.buttonMargin}`)
  const pathologists = getUsers?.data
  let activePathologists = []

  if (pathologists) {
    const filterUserResults = pathologists.filter((value) => {
      if (value.user_roles) {
        return value.user_roles == 'NL_Pathologist' && value.user_status === true
      }
    })
    activePathologists = filterUserResults.map((user) => {
      return { user_name: `${user.first_name} ${user.last_name}`, user_id: Number(`${user.user_id}`) }
    })
  }

  useEffect(() => {
    if (open) dispatch(fetchUsersData())
  }, [open])

  useEffect(() => {
    setTimeout(() => setTranferListLoading(false), 4000)
  }, [isTranferListLoading])

  const onUserIdChange = (val) => {
    if (val === null) setUserId(null)
    if (val.user_id === '') {
      setDisableSubmit(true)
    } else {
      setUserId(val.user_id)
    }
  }
  useEffect(() => {
    if (newUserId) {
      setDisableSubmit(false)
    } else {
      setDisableSubmit(true)
    }
  }, [newUserId])

  const handleCorrectCase = async (event, caseid: any) => {
    setLoading(true)
    setOpenSnackBar(false)
    if (newUserId && userDetails.stage_id !== 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS') {
      await dispatch(
        correction({
          userid: userId,
          newid: newUserId,
          caseid: userDetails?.case_id,
        }),
      )
      setFirstPage(true)
      setTimeout(updateDataTable, 1500)
    } else {
      onClose(true)
    }
  }

  const updateDataTable = async () => {
    setFirstPage(true)
    if (isSearch) {
      await dispatch(
        getSearchByTRFData({
          user_id: user,
          trf_id: trfId,
          user_role: role,
        }),
      )
    } else {
      await dispatch(
        getLabManagerCompleteData({
          id: `${userId}`,
          pageIndex: 1,
          pageSize: gridPageSize,
          filterField: filterName !== '' ? filterName : 'updated_datetime',
          filterValue: filterValue,
          caseView: 'completed',
          startDate: startDate,
          endDate: endDate,
          sortOrder: 'desc',
          sortField: sortField,
        }),
      )
    }
    setOpenSnackBar(true)
    setLoading(false)
    onClose(true)
    // if (re_correction_error) {
    // } else {
    //   setOpenSuccessSnackBar(true)
    //   setUserId(null)
    //   setLoading(false)
    //   onClose(false)
    // }
  }

  function handleCloseDialog() {
    setUserId(null)
    setTranferListLoading(true)
  }

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      {openSnackBar && re_correction_success && (
        <SuccessSnackBar message="Successfully moved the case for correction" />
      )}
      {openSnackBar && re_correction_error && (
        <ErrorSnackBar message="The selected case is already moved to either correction or amend" />
      )}
      <Dialog fullWidth maxWidth="sm" id="hello" open={open} onClose={onClose} style={{ height: '750px' }}>
        <DialogTitle className={classes.dialogTitle}>Correction</DialogTitle>
        <Divider />
        <>
          <DialogContent classes={{ root: classes.dialogContentBox }} style={{ height: '165px' }}>
            <DialogContentText className={classes.dialogContent}>
              {`Select a pathologist to perform the correction to the diagnosis report.
              A new record will be created for the correction workflow and placed in Assigned tab.`}
            </DialogContentText>
            <Autocomplete
              id="combo-box-demo"
              options={activePathologists}
              getOptionLabel={(option: UserBannerPathologist) => option?.user_name}
              onChange={(e, val) => onUserIdChange(val)}
              sx={{ width: 300, marginTop: '15px' }}
              renderInput={(params) => <TextField {...params} label={`Select a pathologist`} />}
            />
            {loading && (
              <CircularProgress className={classes.loadingIndicator} style={{ width: '30px', height: '30px' }} />
            )}
          </DialogContent>
        </>

        <DialogActions className={classes.buttonActions}>
          <Button
            className={getClassNames()}
            onClick={(event) => handleCorrectCase(event, userDetails?.case_id)}
            endIcon={<CheckIcon />}
          >
            Submit
          </Button>
          <Button
            onClick={() => {
              handleCloseDialog()
              onClose()
            }}
            variant="outlined"
            className={classes.buttonMargin}
            endIcon={<ClearIcon />}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
